/* LIVE COPY: snippets/enso-js-pdp-roomfirst.liquid, inlined by snippets/enso-pdp-early.liquid so it runs
   during parsing (30 Sep 2026). assets/enso-pdp-roomfirst.js is a byte copy (themeFilesCopy snippet -> asset after
   every edit); layout still loads it deferred, where it returns at once after the early run. */
/* Enso — PDP "room first" phone first screen (concept B, 14 Sep 2026)
   Runs after enso-pdp-buybox.js. Phones only (<750px). Moves existing nodes
   into the product form so CSS `order` can lay the card out; never clones.
   15 Sep: lead slide chosen by image ALT (same word list as the Liquid preload in
   layout/theme.liquid — keep the two in sync), finish appended to the descriptor,
   "incl. VAT", one-line trust captions, dispatch wording. */
(function () {
  if (window.__ensoRoomFirst) return;
  window.__ensoRoomFirst = true;

  function phone() { return window.matchMedia('(max-width: 749px)').matches; }
  // Room-shot detector. MUST match room_words in layout/theme.liquid.
  var ROOM = /beside a bed|bedroom|bedside|dining|hallway|hall |kitchen|living|lounge|in a room|at night|in situ|at home/i;

  function build() {
    var epc = document.getElementById('epc');
    if (!epc || !phone()) return;
    var buy = epc.querySelector('.epc__buy');
    var form = buy && buy.querySelector('form.epc__form');
    var head = buy && buy.querySelector('.epc__head');
    var ctarow = form && form.querySelector('.epc__ctarow');
    if (!buy || !form || !head || !ctarow) return;

    // 1. name + price into the form, ahead of the CTA
    form.insertBefore(head, form.firstChild);

    // 1b. finish on the descriptor ("LED stick wall light · Brushed Gold") — the Shopping tile
    //     named the finish; the first screen must confirm it. Source: epc-keys.liquid.
    var fin = buy.querySelector('.epc__finishname');
    var desc = head.querySelector('.epc__desc');
    if (fin && desc && fin.textContent.trim() && desc.textContent.toLowerCase().indexOf(fin.textContent.trim().toLowerCase()) < 0) {
      desc.appendChild(document.createTextNode(' · ' + fin.textContent.trim()));
    }
    // 1c. "each, incl. VAT" reads trade — "incl. VAT"
    var small = head.querySelector('.epc__pricewrap small');
    if (small && /each/i.test(small.textContent)) small.textContent = 'incl. VAT';

    // 2. stock + dispatch line (stock state from the section's own markup)
    var ship = document.createElement('p');
    ship.className = 'epc__rfship';
    var inStock = !/sold out|out of stock/i.test((ctarow.textContent || ''));
    ship.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="#23422F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>' +
      '<b>' + (inStock ? 'Made to order' : 'Currently unavailable') + '</b><i>·</i>' +
      '<span>Arrives in 5–7 working days</span>';
    form.insertBefore(ship, ctarow);

    // 3. trust row under the CTA, with a third item for delivery; captions on one line each
    var trust = buy.querySelector('.epc__trust');
    if (trust) {
      var caps = trust.querySelectorAll('div > span');
      Array.prototype.forEach.call(caps, function (s) {
        var t = s.textContent.replace(/\s+/g, ' ').trim();
        var m = t.match(/(\d+)-year/i);
        if (m) s.textContent = m[1] + '-year guarantee';
        else if (/30-day/i.test(t)) s.textContent = '30-day returns';
      });
      var d = document.createElement('div');
      d.innerHTML =
        '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"></path><circle cx="7" cy="17" r="1.5"></circle><circle cx="17" cy="17" r="1.5"></circle></svg>' +
        '<span>Free delivery £40+</span>';
      trust.appendChild(d);
      form.appendChild(trust);
      // 3b. escape route (15 Sep): a Shopping visitor who doesn't like THIS light gets a way to stay
      //     on site instead of going back to Google. Uses the breadcrumb's collection link (the
      //     breadcrumb itself is hidden on phones). Moved link, not cloned.
      var crumbs = epc.querySelectorAll('.epc__crumbs a[href*="/collections/"]');
      var crumb = crumbs.length ? crumbs[crumbs.length - 1] : null;
      if (crumb) {
        var cat = document.createElement('p');
        cat.className = 'epc__rfcat';
        var label = crumb.textContent.replace(/\s+/g, ' ').trim();
        crumb.textContent = 'More ' + label.toLowerCase() + ' →';
        cat.appendChild(crumb);
        trust.insertAdjacentElement('afterend', cat);
      }
    }

    // 4. thumbnails stay on the photo as chips (CSS shows the first two); a "+N" chip and
    //    every chip open the lightbox on that image: scroll the gallery there, then fire the
    //    zoom button, which enso-pdp-lightbox.js intercepts and opens at the current index
    var media = epc.querySelector('.epc__media');
    var tabs = media && media.querySelector('.epc__tabs, .epc__thumbs');
    var track = document.getElementById('epcTrack');
    var zoom = document.getElementById('epcZoom');
    function openAt(i) {
      if (!track || !zoom) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
      setTimeout(function () { zoom.click(); }, 30);
    }
    if (tabs && track) {
      var items = tabs.querySelectorAll('.epc__tab, .epc__thumb');
      // tab buttons carry a label, not an image — paint them with the matching slide
      var slideImgs = track.querySelectorAll('.epc__slide img');
      var paintTabs = function () {
        Array.prototype.forEach.call(items, function (b, i) {
          if (b.classList.contains('epc__tab') && slideImgs[i]) {
            b.style.backgroundImage = 'url("' + (slideImgs[i].currentSrc || slideImgs[i].src) + '")';
          }
        });
      };
      // early run: wait until the slides have picked their srcset size, so the chips reuse it
      if (window.__ensoRunNow && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintTabs);
      else paintTabs();
      if (items.length > 2) {
        var more = document.createElement('button');
        more.type = 'button'; more.className = 'epc__rfmore';
        more.textContent = '+' + (items.length - 2);
        more.setAttribute('aria-label', 'See all ' + items.length + ' photos');
        tabs.appendChild(more);
        more.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openAt(2); }, true);
      }
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.epc__tab, .epc__thumb');
        if (!btn) return;
        var i = btn.dataset.go ? parseInt(btn.dataset.go, 10) - 1
              : Array.prototype.indexOf.call(btn.parentNode.children, btn);
        if (i >= 0) { e.preventDefault(); e.stopPropagation(); openAt(i); }
      }, true);
    }

    // 5. (pill over the photo removed 14 Sep 13:40 at Mike's request — the delivery line lives in the card)

    // 6. (removed 16 Sep 2026) The gallery used to jump to the first image whose alt mentioned a
    //    room. It scrolled rather than reordered, so the viewer landed mid-gallery — on Lira that
    //    was image 8 of 10 — while the thumbnail strip still highlighted image 1, and the <head>
    //    preload fetched an image the DOM never led with. The product's own first image is the
    //    right one to open on. The matching preload branch in layout/theme.liquid is disabled too.
    //    ROOM is kept above so this can be reinstated by restoring this block and that branch.

    // 7. header: transparent while the top of the photo is on screen, solid once it scrolls away
    var stage = epc.querySelector('.epc__stage');
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:120px;pointer-events:none;';
    if (stage) stage.appendChild(sentinel);
    if (stage && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle('enso-rf-scrolled', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(sentinel);
    } else {
      var onScroll = function () { document.body.classList.toggle('enso-rf-scrolled', (window.scrollY || document.documentElement.scrollTop) > 40); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // 8. details block (concept D2): one label/value list built from .epc__meta, .epc__facts and
    //    .epc__eta, which are then hidden by CSS. Links are MOVED (not cloned) so the section's
    //    [data-epc-open] delegation and the #epc-fit anchor keep working.
    (function () {
      var meta = buy.querySelector('.epc__meta');
      var facts = buy.querySelector('.epc__facts');
      var eta = buy.querySelector('.epc__eta');
      var keys = buy.querySelector('.epc__keys');
      if (!keys || (!meta && !facts && !eta)) return;
      var rows = [];
      function esc(t) { return String(t || '').replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
      function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
      function arrow() { return '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M7 17L17 7M9 7h8v8"></path></svg>'; }
      var fitLink = null, tsBtn = null, dlLink = null;

      if (meta) {
        var sw = meta.querySelector('.epc__sw');
        fitLink = meta.querySelector('a.epc__jump');
        if (fitLink) fitLink.remove();
        var parts = txt(meta).split('|').map(function (s) { return s.trim(); }).filter(Boolean);
        if (parts[0]) rows.push({ label: 'Finish', html: (sw ? '<span class="epc__sw" style="' + esc(sw.getAttribute('style')) + '"></span>' : '') + esc(parts[0]) });
        rows.push({ label: 'Size', html: esc(parts[1] || ''), link: fitLink, linkText: 'Size & fit' });
      }
      if (facts) {
        var wiring = [], other = [], bulb = '';
        Array.prototype.forEach.call(facts.querySelectorAll('li'), function (li) {
          if (li.classList.contains('epc__factlink')) { tsBtn = li.querySelector('button, a'); return; }
          var t = txt(li);
          if (!t) return;
          if (!bulb && /bulb|lamp|led|g9|e27|e14|gu10/i.test(t)) bulb = t;
          else if (/hardwired|plug|recharge|battery|dimmable|switched|usb/i.test(t)) wiring.push(t);
          else other.push(t);
        });
        if (bulb) rows.push({ label: 'Bulb', html: esc(bulb.replace(/^\s*bulb[:\s]*/i, '')) });
        if (wiring.length) rows.push({ label: 'Wiring', html: esc(wiring.join(' · ')) });
        if (other.length) rows.push({ label: 'Details', html: esc(other.join(' · ')) });
      }
      if (eta) {
        var dates = txt(eta.querySelector('p b')).replace(/\s+to\s+/, ' – ');
        var days = txt(eta.querySelector('small')).replace(/\s*·\s*Tracked delivery/i, ', tracked').replace(/\bto\b/, '–');
        dlLink = eta.querySelector('a');
        rows.push({ label: 'Delivery', html: '<b>' + esc(dates) + '</b><small>' + esc(days) + ' · free over £40</small>', link: dlLink, linkText: 'Details', stack: true });
      }
      if (tsBtn) rows.push({ label: 'Spec sheet', html: '', link: tsBtn, linkText: 'Tear sheet' });
      if (!rows.length) return;

      var list = document.createElement('div');
      list.className = 'epc__rflist';
      rows.forEach(function (r) {
        var row = document.createElement('div');
        row.className = 'epc__rfrow' + (r.stack ? ' epc__rfrow--stack' : '');
        row.innerHTML = '<span class="epc__rflab">' + esc(r.label) + '</span><span class="epc__rfval">' + r.html + '</span>';
        if (r.link) {
          r.link.textContent = '';
          r.link.insertAdjacentHTML('beforeend', esc(r.linkText) + ' ' + arrow());
          r.link.classList.add('epc__rflink');
          row.querySelector('.epc__rfval').appendChild(r.link);
        }
        list.appendChild(row);
      });
      keys.insertAdjacentElement('afterend', list);
    })();

    // 9. sticky bar only when the real Add to bag is off screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        document.body.classList.toggle('enso-rf-ctavis', entries[0].isIntersecting);
      }, { threshold: 0.2 }).observe(ctarow);
    }

    document.body.classList.add('enso-rf');
  }

  // 30 Sep 2026: snippets/enso-pdp-early.liquid sets window.__ensoRunNow and runs this while the
  // page is still parsing (as soon as .epc__secure exists), so the phone card is built before the
  // first paint. Before, it ran after parsing and the options jumped ~340px on slow phones.
  if (window.__ensoRunNow || document.readyState !== 'loading') build();
  else document.addEventListener('DOMContentLoaded', build);
})();
